import React, { ReactNode, useMemo } from 'react';

import { BlackTooltip } from '@/components/alerts/Tooltip';
import { ENV } from '@/constants/env';
import { ONE_SEC_MS } from '@/constants/time';
import { Sidebar } from '@/features/sidebar/components/Sidebar';
import { useSidebarVisible } from '@/features/sidebar/hooks';

import { usePageContainerContext } from '../../providers/PageContainerContext';
import { PageHeading } from '../PageHeading';
import {
    StyledContainer,
    StyledContent,
    StyledFooter,
    StyledHeading,
    StyledSpacing,
    StyledWrapper,
} from './PageContainer.styles';

const COPYRIGHT_YEAR = new Date().getFullYear();

export const PageContainer = ({ children }: { children: ReactNode }) => {
    const { isSidebarVisible, setSidebarVisible } = useSidebarVisible();
    const { isFullPage } = usePageContainerContext();

    const footer = useMemo(
        () => (
            <>
                <StyledSpacing />
                <StyledFooter>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <BlackTooltip title={`v${ENV.VERSION}`} enterDelay={ONE_SEC_MS}>
                            <span>&copy;</span>
                        </BlackTooltip>
                        <span>{COPYRIGHT_YEAR} ABONOTEATRO</span>
                    </div>
                </StyledFooter>
            </>
        ),
        [],
    );

    return (
        <StyledWrapper>
            {isFullPage ? null : <Sidebar isSidebarVisible={isSidebarVisible} setSidebarVisible={setSidebarVisible} />}
            <StyledContainer fullpage={isFullPage}>
                {isFullPage ? null : (
                    <StyledHeading>
                        <PageHeading isSidebarVisible={isSidebarVisible} setSidebarVisible={setSidebarVisible} />
                    </StyledHeading>
                )}
                <StyledContent fullpage={isFullPage}>{children}</StyledContent>
                {isFullPage ? null : footer}
            </StyledContainer>
        </StyledWrapper>
    );
};
